(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bdt-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!window.bdtImageShowcaseEditorEventsBound) {
    window.bdtImageShowcaseEditorEventsBound = true;

    document.addEventListener('shopify:block:select', function (event) {
      var selectedCard = event.target.closest('.bdt-image-showcase__item');

      if (selectedCard) {
        selectedCard.scrollIntoView({
          behavior: event.detail && event.detail.load ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
